import $ from 'jquery'
import Base from 'luminate/src/modules/base'

const Map = Base.extend({
	directive: 'map',

	defaults: {
		lat: 0,
		lng: 0,
		zoom: 0,
		label: false
	},

	events: {

		init: function()
		{
			if(!window.google)
			{
				throw new Error('Google Maps API is missing')
			}

			const point = new google.maps.LatLng(this.$settings.lat, this.$settings.lng)

			this.map = new google.maps.Map(this.$element, {
				center: point,
				zoom: this.$settings.zoom,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				disableDefaultUI: true,
				draggable: false,
				scrollwheel: false
			})

			if(this.$settings.label)
			{
				this.marker = new google.maps.Marker({
					map: this.map,
					position: point,
					title: this.$settings.label
				})
			}

			$(window).on('resize', e => {
				this.map.setCenter(point)
			})
		}
	}
})

export default Map



// WEBPACK FOOTER //
// ./public/scripts/src/modules/map.js